module.exports = __webpack_public_path__ + "img/4.3 PnL Simulation.b79c6e04.jpg";